function GoBackIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
            className={className}
        >
            <path
                stroke="var(--mainText)"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M22.5 12.5h-20M9.5 19.5l-7-7 7-7"
            ></path>
        </svg>
    )
}

export default GoBackIcon
